// AdminBccToggles.jsx — independent "BCC Edward" / "BCC James" checkboxes,
// shared by every outbound email dialog (Raise PO, Send to Client, Save &
// Email) so they all follow one pattern. Always BCC, never CC: the client
// never sees our addresses.

import React from "react";

export const EDWARD_EMAIL = "edward@sublimeprecision.co.uk";
export const JAMES_EMAIL = "james@sublimeprecision.co.uk";

// value: { edward: bool, james: bool } -> the bcc address list to send with.
export function adminBccList(value) {
  return [value?.edward && EDWARD_EMAIL, value?.james && JAMES_EMAIL].filter(Boolean);
}

// compact: one inline row ("BCC: ☑ Edward ☐ James", addresses on hover) for
// sitting directly under an email field; otherwise one labelled row each.
export default function AdminBccToggles({ value, onChange, disabled, compact }) {
  const rows = [
    { key: "edward", label: "BCC Edward", short: "Edward", email: EDWARD_EMAIL },
    { key: "james", label: "BCC James", short: "James", email: JAMES_EMAIL },
  ];
  if (compact) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 14, fontSize: 12, color: "#4a5568" }}>
        <span style={{ fontWeight: 600 }}>BCC:</span>
        {rows.map(r => (
          <label key={r.key} title={r.email} style={{ display: "inline-flex", alignItems: "center", gap: 5, cursor: disabled ? "default" : "pointer", color: "#1a1a2e" }}>
            <input
              type="checkbox"
              checked={!!value?.[r.key]}
              onChange={e => onChange({ ...value, [r.key]: e.target.checked })}
              disabled={disabled}
              style={{ width: 14, height: 14, margin: 0, cursor: disabled ? "default" : "pointer" }}
            />
            {r.short}
          </label>
        ))}
      </div>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {rows.map(r => (
        <label key={r.key} style={{ display: "flex", alignItems: "center", gap: 8, cursor: disabled ? "default" : "pointer", fontSize: 13, color: "#1a1a2e" }}>
          <input
            type="checkbox"
            checked={!!value?.[r.key]}
            onChange={e => onChange({ ...value, [r.key]: e.target.checked })}
            disabled={disabled}
            style={{ width: 16, height: 16, cursor: disabled ? "default" : "pointer" }}
          />
          {r.label}
          <span style={{ fontSize: 11, color: "#8ab0cc" }}>({r.email})</span>
        </label>
      ))}
    </div>
  );
}
